import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) {
      nav("/", { replace: true });
      return;
    }

    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        if (setUser) setUser(data);
        // Clear hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => {
        nav("/", { replace: true });
      });
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-sm" style={{ color: "var(--text-2)" }}>
        <Loader2 className="w-5 h-5 animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
